// AddCredits Page
import React from 'react';
import { NextSeo } from 'next-seo';
import { NextPageWithLayout } from 'types/page';
import AddCreditsView, { AddCreditsProps } from 'components/views/AddCredits';
import { GetStaticProps } from 'next';
import { getPackages } from 'api/payment';
import AuthPageProtection from 'components/containers/AuthProtection';

/**
 * AddCredits: Page description
 * @return {NextPageWithLayout}
 */
const PageTitle = 'Add Credits';
const AddCredits: NextPageWithLayout<AddCreditsProps> = ({
  creditPackages,
}) => {
  return (
    <>
      <NextSeo title={PageTitle} />
      <AuthPageProtection>
        <AddCreditsView creditPackages={creditPackages} />
      </AuthPageProtection>
    </>
  );
};

export default AddCredits;

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export const getStaticProps: GetStaticProps<AddCreditsProps> = async () => {
  const creditPackages = await getPackages();
  return {
    props: { creditPackages },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 1000 seconds
    // revalidate: 1000,
  };
};
